<script setup lang="ts">
import { BsInput, BsError } from '@afo/bsf-core'
import type { IProps, IEmits } from './NumericInput.types'

const props = withDefaults(defineProps<IProps>(), { trim: true })
const emit = defineEmits<IEmits>()

const onUpdateText = (event: string) => {
  let strippedValue = props.trim ? event.trim().replace(',', '.') : event.replace(',', '.')
  emit('update:modelValue', Number.isNaN(Number(strippedValue)) ? strippedValue : Number(strippedValue))
}
</script>

<template>
  <BsError :message="errorMessage">
    <BsInput
      v-bind="$attrs"
      inputmode="numeric"
      @update:model-value="onUpdateText($event)"
    />
  </BsError>
</template>
